var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['grid', _vm.className],style:({
    'grid-template-columns': _vm.gridTemplateColumns,
    'grid-gap': _vm.gridGap
  })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }